<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters, mapActions, mapState } from "vuex";
import moment from "moment";
import axios from "axios";
// import QrcodeVue from 'qrcode.vue'

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Sales Report",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    // QrcodeVue,
    PageHeader,
  },
  data() {
    return {
      value: "https://example.com",
      size: 300,
      title: "Sales Report",
      items: [
        {
          text: "Home",
          href: "#/",
        },
        {
          text: "Sales Report",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
         {
          key: "drug_name",
          sortable: true,
          label: "Name",
        },
        {
          key: "code",
          sortable: true,
          label: "CODE",
        },
        {
          key: "total",
          sortable: true,
          label: "TOTAL",
        },
        {
          key: "paid",
          sortable: true,
          label: "PAID",
        },{
          key: "balance",
          sortable: true,
          label: "BALANCE",
        },
      
        {
          key: "saleDate",
          sortable: true,
          label: "DATE",
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      data: {
        dto: moment(new Date()).format("YYYY-MM-DD"),
        dfrom: "",
        category: "",
      },
      totals: {
        totalAmount: 0,
        totalTot: 0,
      },

      filterTitle: "",
      filteredReport: [],
    };
  },
  computed: {
    ...mapGetters("sales", ["SalesReport"]),
    ...mapState("sales", ["sales_report"]),
    ...mapGetters("auth", ["user_permissions"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.filteredReport ? this.filteredReport.length : 1;
    },
  },
  watch: {
    sales_report(newValue) {
      if (newValue.data.length > 0) {
        this.assiginData();
      }
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.filteredReport ? this.filteredReport.length : 1;
  },
  methods: {
    ...mapActions({
      FetchSales: "sales/fetchSalesReport",
    }),
    // COMMA SEPERATORS
    thousandSeprator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    assiginData() {
      this.filteredReport = this.SalesReport;
      this.filterReport();
    },
    Excel_export() {
      axios
        .post("export_sales", this.data, {
          responseType: "arraybuffer",
        })
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", "sales.xlsx");
          document.body.appendChild(fileLink);
          fileLink.click();
          this.$toast.add({
            severity: "success",
            summary: "Successful",
            detail: "Sales Report Downloaded successfully",
            life: 6000,
          });
          this.spinner = false;
        })
        .catch(() => {
          this.spinner = false;
          this.$toast.add({
            severity: "error",
            summary: "Something wrong",
            detail: "Sales Report Download failed",
            life: 6000,
          });
        });
    },

    filterReport() {
      this.totals.totalAmount = 0;
      this.totals.totalTot = 0;
      let date2 = this.data.dto;
      let date1 = this.data.dfrom;
      let total = 0;
      let tot = 0;
      this.filteredReport = this.SalesReport.filter((element) => {
        if (this.data.dfrom == "" && this.data.dto != "") {
          if (element.filterDate <= date2) {
            let amt = parseInt(element.amountPaid);
            total = total + amt;

            let amt1 = parseInt(element.totalAmount);
            tot = tot + amt1;

            this.totals.totalAmount = total;
            this.totals.totalTot = tot;
          }

          return element.filterDate <= date2;
        } else if (this.data.dfrom != "" && this.data.dto != "") {
          this.filterTitle =
            "Sales Report From " + this.data.dfrom + " To " + this.data.dto;
          if (element.filterDate >= date1 && element.filterDate <= date2) {
            let amt = parseInt(element.amountPaid);
            total = total + amt;

            let amt1 = parseInt(element.totalAmount);
            tot = tot + amt1;
            this.totals.totalAmount = total;
            this.totals.totalTot = tot;
          }

          return element.filterDate >= date1 && element.filterDate <= date2;
        }
      });
    },
    reprint(id) {
      window.open(
        `https://${window.location.host}/preciept/salereprint.php?id=${btoa(id)}`
      );
    },
  },
  created() {
    this.FetchSales();
    this.assiginData();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <!-- <qrcode-stream></qrcode-stream> -->
    <!-- <qrcode-drop-zone></qrcode-drop-zone> -->
    <!-- <qrcode-capture></qrcode-capture> -->
    <!-- <template>
  <qrcode-vue :value="value" :size="size" />
</template> -->
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div v-if="filterTitle">
                <h4>
                  <center>{{ filterTitle }}</center>
                </h4>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <label>From</label>
                  <input
                    @change="filterReport()"
                    type="date"
                    v-model="data.dfrom"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <label>To</label>
                  <input
                    @change="filterReport()"
                    type="date"
                    v-model="data.dto"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-4"></div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <b-button class="mb-3" variant="primary" @click="Excel_export()"
                  ><i class="fa fa-download"></i>Export</b-button
                >

                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                foot-clone
                :items="filteredReport ? filteredReport : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                   <template #cell(drug_name)="data">
                  {{data.item.sale_detail[0].item.drug }}
                </template>
                <template #cell(total)="data">
                  {{ thousandSeprator(data.item.totalAmount) }}
                </template>
                <template #cell(paid)="data">
                  {{ thousandSeprator(data.item.amountPaid) }}
                </template>
                <template #cell(branch)="data">
                  {{ data.item.branch.name }}
                </template>

                <template #foot(total)="">
                  {{ thousandSeprator(totals.totalAmount) }}
                </template>
                <template #foot(paid)="">
                  {{ thousandSeprator(totals.totalTot) }}
                </template>
                <template #foot(branch)=""> <span class="text-danger"></span></template>
                <template #foot(actions)=""> <span class="text-danger"></span></template>
                <template #foot(saleDate)=""> <span class="text-danger"></span></template>
                <template #cell(actions)="data">
                  <button
                    v-if="user_permissions.reprint_sale_receipt"
                    class="btn btn-outline-primary btn-sm"
                    @click="reprint(data.item.id)"
                  >
                    <i class="fa fa-print"></i> Reprint
                  </button>
                  <button v-else disabled class="btn btn-outline-primary btn-sm">
                    <i class="fa fa-ban"></i> Reprint
                  </button> |
                  <router-link :to="{ name: 'SaleDetail', params: {id: data.item.id }}">
                    <button class="btn btn-outline-secondary btn-sm">
                      <i class="fa fa-eye"></i> Details
                    </button>
                  </router-link>
                </template>
              </b-table>
              <center>
                <h3 v-if="!SalesReport" class="text-primary">
                  <b-spinner class="m-0" variant="primary" role="status"></b-spinner>
                  Please wait...
                </h3>
              </center>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
